export default __webpack_public_path__ + "static/media/3.e8cd4c09.jpg";